
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plugins/[slug]",
      function () {
        return require("private-next-pages/plugins/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/plugins/[slug]"])
      });
    }
  